import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Section: Recommended Products
 * ------------------------------------------------------------------------------
 * Configured section to display Directed Edge recommended products.
 *
 * @namespace recommendedProducts
 */

import { register } from '@shopify/theme-sections';
import cssClasses from '~/helpers/cssClasses';
import Carousel from '~/components/carousel';
import RecommendedProducts from '~/components/templates/recommended-products';
/**
 * DOM selectors.
 */

const selectors = {
  section: '[js-recommended-products="section"]',
  container: '[js-recommended-products="carousel"]',
  cell: '[js-recommended-products="slide"]',
  prevButton: '[js-recommended-products="prev"]',
  nextButton: '[js-recommended-products="next"]'
};
/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 */

register('recommended-products', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors() {
    const section = "[data-section-id=\"".concat(this.id, "\"]").concat(selectors.section);
    const container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    const cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    const prevButton = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.prevButton);
    const nextButton = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.nextButton);
    this.cache = {
      section,
      container,
      cells,
      nextButton,
      prevButton
    };
  },

  setNodeSelectors() {
    this.section = document.querySelector(this.cache.section);
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel() {
    Carousel(this.cache.container, {
      swiper: {
        centeredSlides: true,
        navigation: {
          nextEl: this.cache.nextButton,
          prevEl: this.cache.prevButton
        },
        slidesPerView: 3
      }
    }).init();
  },

  /**
  * Construct slides.
  * @param {Object} array - array of recommended product data for slides.
  */
  constructSlides(slideData) {
    const swiperWrapper = document.querySelector('.recommended-products__carousel .swiper-wrapper');
    [...slideData].forEach(item => {
      swiperWrapper.insertAdjacentHTML('beforeend', RecommendedProducts(item));
    });
    this.constructCarousel();
  },

  /**
   * Get recommended products data.
   */
  getRecommendedProductsData() {
    const recommendations = document.querySelector('.recommendations');
    const products = recommendations.querySelectorAll('ul');
    const slideData = [...products].map(product => {
      const id = {
        id: product.classList[0].split('product-')[1],
        url: product.querySelector('.url').innerHTML,
        image: product.querySelector('.image').innerHTML,
        altImage: product.querySelector('.alt_image').innerHTML,
        title: product.querySelector('.title').innerHTML,
        price: product.querySelector('.price').innerHTML
      };
      return id;
    });
    this.constructSlides(slideData);
  },

  setEventBusListeners() {
    Frame.EventBus.listen('DirectedEdge:loaded', () => {
      this.section.classList.remove(cssClasses.hidden);
      this.getRecommendedProductsData();
    });
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad() {
    this.cacheSelectors();
    this.setNodeSelectors();
    this.setEventBusListeners();
  }

});